"use client";

import type { ProductSummary, PublicSettings } from "@plexstore/types";

import HalftoneWordmarkFooter, { type FooterColumn, type FooterLink } from "@/components/ui/halftone-wordmark-footer";

interface FooterProps {
  settings: PublicSettings;
  products: ProductSummary[];
}

export function Footer({ settings, products }: FooterProps) {
  const year = new Date().getFullYear();
  const storeName = settings.storeName.trim() || "Void Services";

  const storeLinks: FooterLink[] = [
    { label: "Products", href: "/products" },
    { label: "Reviews", href: "/reviews" },
    ...(settings.displayFeatures && settings.features.length > 0 ? [{ label: "Features", href: "/#features" }] : []),
    ...(settings.displayFAQ && settings.faqs.length > 0 ? [{ label: "FAQ", href: "/#faq" }] : []),
    ...products.filter((product) => !product.hideProduct).map((product) => ({ label: product.name, href: `/products/${product.urlId}` })),
  ];

  const accountLinks: FooterLink[] = [
    { label: "Browse products", href: "/products" },
    ...(settings.discordInviteLink ? [{ label: "Join Discord", href: settings.discordInviteLink }] : []),
    { label: "Sign in", href: "/login" },
  ];

  const legalLinks: FooterLink[] = [
    ...settings.customFooterTabs.map((tab) => ({ label: tab.name, href: tab.link })),
    { label: "Terms", href: "/tos" },
    { label: "Privacy", href: "/privacy-policy" },
  ];

  const columns: FooterColumn[] = [
    { title: "Store", links: storeLinks },
    { title: "Account", links: accountLinks },
    { title: "Legal", links: legalLinks },
  ];

  return (
    <HalftoneWordmarkFooter
      wordmark={storeName.toLowerCase()}
      label={storeName}
      meta={`© ${year} · All rights reserved`}
      columns={columns}
      preset="night"
      palette={{ background: "rgba(3,5,10,0.55)", ink: "#e7eefc", warm: "#1677FF" }}
    />
  );
}
